import React from 'react';
import clsx from "clsx";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
//import Paper from "@material-ui/core/Paper";
import {useStyles } from './../Complements/usesStyles'


const MainSimple = props => {
    const {  body } = props
    const classes = useStyles(props);
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    return (
        <main style={{/* backgroundColor : "#EEEFF2" */}}>
        <Container maxWidth="lg" style={{/* backgroundColor : "#EEEFF2" */}}>
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              
            <div className={fixedHeightPaper}>  { body } </div>
              
            </Grid>
          </Grid>
        </Container>
      </main>
    );
};

/* MainSimple.propTypes = {
    
}; */

export default MainSimple;